import styles from './CommentPage.module.css'
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useState } from 'react';
import icEdit from './../../image/ic_edit.svg'
import icDelete from './../../image/ic_delete.svg'
import { useLongPress } from '@uidotdev/usehooks';
import { ModalAction } from '../../components/ModalActions/ModalAction';
export const CommentItem = (
    {
        uName,
        uMsg,
        msgDate,
        onChange,
        onDelete,
        isEdit
    }
    :
    {
        uName:string|null
        uMsg:string|null
        msgDate:string|null
        onChange:()=>void
        onDelete:()=>void
        isEdit:boolean
    }) =>{
        const [isAction,setIsAction] = useState(false)
        const attrs = useLongPress(
    () => {
      if(isEdit)setIsAction(true);
    },
    {
      onStart: (event) => console.log("Press started"),
      onFinish: (event) => console.log("Press Finished"),
      onCancel: (event) => console.log("Press cancelled"),
      threshold: 500,
    }
  );
  
    return(
        <div className={styles.comment_page_item_container} {...attrs}>
            <Avatar size={32} icon={<UserOutlined/>}/>
            <div className={styles.comment_page_item_body}>
                <div className={styles.comment_page_item_body_title}>{uName}</div>
                <div className={styles.comment_page_item_body_text}>{uMsg}</div>
                <div className={styles.comment_page_item_body_foother}>{msgDate}</div>
            </div>
             {isAction&&<ModalAction items={
                [
                {name:"Редактировать",action:()=>
                    {
                        onChange()
                        setIsAction(false)
                    },
                    icon:icEdit},
                {name:"УДалить",action:()=>{onDelete()},icon:icDelete}
                ]}/>}
        </div>
    )
}